import type { SetAudioPlayerAction } from "domains/audioPlayer/actionTypes";
import { AudioPlayerTypes } from "domains/audioPlayer/actionTypes";

export const setAudioPlayer = (meta: SetAudioPlayerAction["meta"]): SetAudioPlayerAction => ({
  type: AudioPlayerTypes.SET,
  meta,
});
